const schema = [
        ['name'],
        ['description'],
        ['roles'],
];

export default schema;
